import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import request from 'sb-request'
import { constants, isNotEmpty, getRandomId } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import Carousel from 'components/ui/Carousel/Carousel'

import s from './BrandsSlider.scss'


const options = {
  className: s.carousel,
  dots: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  responsive: [{
    breakpoint: constants.media.desktopStart,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
    },
  }, {
    breakpoint: constants.media.mobileEnd,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
    },
  }],
}

class BrandsSlider extends Component {

  static propTypes = {
    gender: PropTypes.oneOf(['male', 'female']),
  }

  state = {
    brandsLists: [],
  }

  componentDidMount = () => {
    const { gender } = this.props

    request.post('graphql?name=perfumesByBrands', {
      body: {
        query: `{
          brandsLists: perfumesByBrands(gender: "${gender}") {
            brand
            titles
          }
        }`,
      },
    })
      .then(({ brandsLists }) => {
        this.setState({
          brandsLists: this.splitArray(brandsLists, 3),
        })
      })
  }

  splitArray = (array, chunkSize) => {
    let newArray = []

    for (let i = 0; i < array.length; i += chunkSize) {
      newArray.push(array.slice(i, i + chunkSize))
    }

    return newArray
  }

  render() {
    const { brandsLists } = this.state

    return isNotEmpty(brandsLists) && (
      <div className={s.container}>
        <Carousel options={options}>
          {
            brandsLists.map((brands, index) => (
              <div key={index} className={s.box}>
                {
                  brands.map(({ brand, titles }, brandIndex) => {
                    const productsId = getRandomId('products')

                    return (
                      <Box key={brandIndex} className={s.brandContainer} pt="16" pl="8" pr="8">
                        <div role="group">
                          <Box className={s.brand} alignCenter>
                            <Box className={s.titleContainer} p="8">
                              <Text message={brand} id={productsId} size="18-24" semibold />
                            </Box>
                            {
                              isNotEmpty(titles) && (
                                <div className={s.products} aria-describedby={productsId} role="list">
                                  {
                                    titles.map((title, index) => (
                                      <Box className={s.product} key={index} ml="8" mr="8">
                                        <Text size="12-16" uppercase muted>
                                          <span role="listitem">{title}</span>
                                        </Text>
                                      </Box>
                                    ))
                                  }
                                </div>
                              )
                            }
                          </Box>
                        </div>
                      </Box>
                    )
                  })
                }
              </div>
            ))
          }
        </Carousel>
      </div>
    )
  }
}


export default connect({
  gender: 'models.me.gender',
})(BrandsSlider)
